import React from "react";
import { createGlobalStyle } from "styled-components";
import { deprecationWarning } from "../../private/helpers";
var GlobalStyle = createGlobalStyle(["@font-face{font-family:'Museo-Sans';font-display:swap;src:url('https://assets.reastatic.net/common/museo-sans-300-v1.woff2') format('woff2'),url('https://assets.reastatic.net/common/museo-sans-300-v1.woff') format('woff');font-weight:300;}@font-face{font-family:'Museo-Sans';font-display:swap;src:url('https://assets.reastatic.net/common/museo-sans-500-v1.woff2') format('woff2'),url('https://assets.reastatic.net/common/museo-sans-500-v1.woff') format('woff');font-weight:500;}@font-face{font-family:'Museo-Sans';font-display:swap;src:url('https://assets.reastatic.net/common/museo-sans-700-v1.woff2') format('woff2'),url('https://assets.reastatic.net/common/museo-sans-700-v2.woff') format('woff');font-weight:700;}body{font-family:'Museo-Sans','Helvetica Neue',Helvetica,Arial,sans-serif;font-weight:300;}"]);
var PreloadLinks = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("link", {
  rel: "preload",
  href: "https://assets.reastatic.net/common/museo-sans-300-v1.woff2",
  as: "font",
  type: "font/woff2",
  crossOrigin: "anonymous"
}), /*#__PURE__*/React.createElement("link", {
  rel: "preload",
  href: "https://assets.reastatic.net/common/museo-sans-500-v1.woff2",
  as: "font",
  type: "font/woff2",
  crossOrigin: "anonymous"
}), /*#__PURE__*/React.createElement("link", {
  rel: "preload",
  href: "https://assets.reastatic.net/common/museo-sans-700-v1.woff2",
  as: "font",
  type: "font/woff2",
  crossOrigin: "anonymous"
}));

// Note, technically these <link> tags are only supposed to be in the <head>,
// however browsers still seem to respect it if it's in the body.
// Also, this is only done for the `woff2` versions and any browser that
// doesn't support `woff2` won't support preloading either.

/**
 *  @deprecated MuseoSans is deprecated and should be replaced by Pangea.
 *  please see [Pangea](https://construct-kit.reainternal.net/web/core/pangea).
 *
 * Loads MuseoSans font from the CDN
 *
 * @see [MuseoSans documentation](https://construct-kit.reainternal.net/components/web/core/museo-sans)
 * */
var MuseoSans = _ref => {
  var {
    renderPreloadLinks = true
  } = _ref;
  deprecationWarning("MuseoSans is deprecated and should be replaced by Pangea, please see https://construct-kit.reainternal.net/web/core/pangea");
  return /*#__PURE__*/React.createElement(React.Fragment, null, renderPreloadLinks && /*#__PURE__*/React.createElement(PreloadLinks, null), /*#__PURE__*/React.createElement(GlobalStyle, null));
};
MuseoSans.displayName = "MuseoSans";
export default MuseoSans;